export default __webpack_public_path__ + "static/media/logo_wide.733d0f0f.jpg";